<template>
  <Step v-if="!is_loading">

    <div id="show-result" class="w-full flex flex-col items-center max-w-xl mb-4">
      <img class="mb-4 max-w-lg s-image" :src="results_pic" />
      <div class="flex flex-col items-center mt-4 mb-4">
        <div class="max-w-sm flex flex-col items-center">
          <p class="text-lg">Based on your responses, these are possible conditions. Click each link to learn more.</p>
        </div>
      </div>
      <div class="flex flex-col s-text-left">
        <p> 
          <a class="underline text-blue-500" target="_blank" :href="exam_results.conditions[0].meta.links[0].url">{{ exam_results.conditions[0].name }}</a> 
            <br>
            <span class="percent first">{{ exam_results.conditions[0].confidence }}% </span>
            <span class="percent">confidence</span> 
        </p>
        <p>
          <a class="underline text-blue-500" target="_blank" :href="exam_results.conditions[1].meta.links[0].url">{{ exam_results.conditions[1].name }}</a>
            <br>
            <span class="percent">{{ exam_results.conditions[1].confidence }}% confidence</span> 
        </p>
        <p> 
          <a class="underline text-blue-500" target="_blank" :href="exam_results.conditions[2].meta.links[0].url">{{ exam_results.conditions[2].name }}</a>
            <br>
            <span class="percent">{{ exam_results.conditions[2].confidence }}% confidence</span> 
        </p>
      </div>
    </div>
  </Step>
</template>

<style lang="scss" scoped>
.s-text-left {
  // display: flex;
  font-weight: bold;
  font-size: 1.8em;
  margin-bottom: 3px;
  p {
    margin-bottom: 0.2em;
  }
}  
.percent {
  color: slategray;
  &.first {
    color: limegreen;
  }
}
@media (max-width: 768px) {
  .s-text-left {
    font-size: 1.1em;
  }
}

.s-spacer {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 24rem;
  padding-bottom: 0.2em;
  margin-bottom: 0.5em;
  border-bottom: 2px rgba(black, 0.7) solid;
  justify-content: space-between;
}
.s-image {
  width: 100%;
  max-width: 1000px;
}

.s-text-apart {
  text-align: left;
  :nth-last-child(1) {
    text-align: right;
  }
}
</style>

<script>
import Step from "../components/Step";
import { mapState } from "vuex";

export default {
  name: "ShowResults",
  components: {
    Step
  },
  computed: {
    ...mapState(["results_pic", "exam_results", "exam_type", "exam_responses", "is_loading"]),
    condition_title() {
      // if (this.exam_results) return this.exam_results;
      // else
      return 'Likely Conditions'
    },
    exam_type_link() {
      let link;
      switch(this.exam_type) {
        case('knee'):
          link = "https://www.myorthopedicproblem.com/knee";
          break;
        case('hip'):
          link = "https://www.myorthopedicproblem.com/hip";
          break;
        case('shoulder'):
          link = "https://www.myorthopedicproblem.com/shoulder";
          break;
      }
      return link;
    }
  },
};
</script>